/* eslint-disable no-unused-vars */
import Links from "../Data/HPLinks";
import { Link } from "react-router-dom";

const Home = ({ activeFilter }) => {
  return (
    <div className="w-full h-max flex flex-row flex-wrap lg:p-2">
      {Links.filter(
        (item) => activeFilter === "all" || item.type === activeFilter
      ).map((item, index) => (
        <div
          className="w-1/2 h-60 md:w-1/3 md:h-64 lg:w-40 lg:h-56 p-2"
          key={index}
        >
          <Link to={item.link}>
            <div className="w-full h-full overflow-hidden border-2 border-zinc-400/50 hover:border-themeGreen/50 transition-all duration-300 ease-[cubic-bezier(0.4, 0, 0.2, 1)] hover:shadow-[0_4px_10px_rgba(0,0,0,0.7)]">
              <div className="w-full h-3/4 object-contain object-center overflow-hidden">
                <img
                  src={item.image}
                  alt="link visual"
                  className="w-full h-full object-cover"
                ></img>
              </div>
              <div className="flex flex-col bg-zinc-700/40 backdrop-blur-sm justify-center items-center w-full h-1/4 text-center font-pathway font-semibold tracking-widest">
                <p>{item.name}</p>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default Home;
